import {
  ADD_SEARCH_DATA,
  UPDATE_SEARCH_DATA_INPROGRESS,
  SEARCH_DATA_ERROR,
  SEARCH_DATA_SUCCESS,
} from '../../../actions'

const initialState = {
  data: [],
  trfId: '',
  fetchInProgress: false,
}

export const getSearchByTRFDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_SEARCH_DATA:
      return { ...state, data: action.payload.data, trfId: action.trfId }
    case UPDATE_SEARCH_DATA_INPROGRESS:
      return { ...state, fetchInProgress: action.inProgress, trfId: action.trfId }
    default:
      return state
  }
}

const sendSlide = {
  re_search_success: false,
  re_search_error: false,
}

export const searchDataResponseReducer = (state = sendSlide, action) => {
  switch (action.type) {
    case SEARCH_DATA_SUCCESS:
      return { ...state, re_search_success: true, re_search_error: false }
    case SEARCH_DATA_ERROR:
      return { ...state, re_search_success: false, re_search_error: true }

    default:
      return state
  }
}
